// @flow
import type { Group as ApiGroup } from 'api/groups';
import type { Action } from '../actions/groups';

export type Group = {
  ...$Exact<ApiGroup>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: Group
  }
};

export default function groups(state: State = { byId: {} }, action: Action) {
  switch (action.type) {
    case 'FETCH_GROUP_REQUEST':
      return {
        byId: {
          ...state.byId,
          [action.groupId]: {
            ...state.byId[action.groupId],
            id: action.groupId,
            isFetching: true
          }
        }
      };
    case 'FETCH_GROUP_SUCCESS':
      return {
        byId: {
          ...state.byId,
          [action.group.id]: {
            ...action.group,
            isFetching: false
          }
        }
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
